import { strings } from '@/constants/strings';
import { urls } from '@/constants/urls';
import { DynamicNavItem } from '@/types/dynamic-nav-item';

export const platformAdminNestedOrganisationNavItems: DynamicNavItem<{
  id: number;
}>[] = [
  {
    title: 'Groups',
    to: ({ id }) => urls.organisations.organisation.groups.base.compose(id),
    tooltip: strings.sidebar.groups.tooltip,
  },
  {
    title: 'Units',
    to: ({ id }) => urls.organisations.organisation.units.compose(id),
    tooltip: strings.sidebar.units.tooltip,
  },
  {
    title: 'Devices',
    to: ({ id }) => urls.organisations.organisation.devices.compose(id),
    tooltip: strings.sidebar.devices.tooltip,
  },
  {
    title: 'Policies',
    to: ({ id }) => urls.organisations.organisation.policies.compose(id),
    tooltip: strings.sidebar.policies.tooltip,
  },
  {
    title: 'Users',
    to: ({ id }) => urls.organisations.organisation.users.compose(id),
    tooltip: strings.sidebar.users.tooltip,
  },
  {
    title: 'Dashboard',
    to: urls.reporting.base,
    tooltip: strings.sidebar.dashboard.tooltip,
  },
];
